module.exports = __webpack_public_path__ + "img/logo.a2f28b38.png";